<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <!--表格-->
            <div class="tbl-scroll-host">
            <el-table :data="users" v-loading="listLoading" class="compact-table" style="width: 100%;" height="100%">
                <el-table-column prop="Name" label="姓名" width="">
                </el-table-column>
                <el-table-column prop="Account" label="登录账号" width="">
                </el-table-column>
                <el-table-column label="人员类型" width="" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.PersonType === 1 ? 'warning' : 'info'">
                            {{ scope.row.PersonType === 1 ? '教职工' : '学生' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="业务范围" width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" :type="scope.row.BizScope === 'Both' ? 'success' : 'info'">
                            {{ formatBizScope(scope.row.BizScope) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="黑板报" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.CanBlackboard ? 'success' : 'info'" size="small">
                            {{ scope.row.CanBlackboard ? '是' : '否' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="权限等级" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsAdmin ? 'danger' : ''" size="small">
                            {{ scope.row.IsAdmin ? '管理员' : '普通' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="关联人员" width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.PersonType === 0 && Number(scope.row.StudentId) === -1" type="warning"
                            size="mini" effect="plain">全校学生</el-tag>
                        <el-tag v-else-if="scope.row.PersonType === 0 && Number(scope.row.StudentId) > 0" type="success"
                            size="mini" effect="plain">{{
                            scope.row.StudentName }}</el-tag>
                        <el-tag v-else-if="scope.row.PersonType === 1 && Number(scope.row.TeacherId) > 0" type="primary"
                            size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
                        <el-tag v-else-if="scope.row.PersonType === 1" type="warning" size="mini" effect="plain">全部教职工</el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="DepartmentName" label="所属部门" min-width="200" show-overflow-tooltip>
                </el-table-column> -->
                <el-table-column label="所属校区" min-width="160" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="getCampusName(scope.row.CampusId) !== '-'">{{ getCampusName(scope.row.CampusId) }}</span>
                        <span v-else style="color: #909399;">全校</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Enabled" label="状态" width="" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled ? 'success' : 'danger'">
                            {{ scope.row.Enabled ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" width="" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="" align="center">
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <!--分页-->
            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <!--编辑界面-->
            <!-- 编辑：左右分栏；人员区压成两行。最后更新：2026-09-21 -->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="820px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm" class="duty-staff-edit-form">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="人员类型" prop="PersonType">
                                <el-radio-group v-model="editForm.PersonType" @change="handlePersonTypeChange"
                                    :disabled="editForm.Id > 0">
                                    <el-radio :label="0">学生</el-radio>
                                    <el-radio :label="1">教职工</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="所属校区" prop="CampusId">
                                <el-select v-model="editForm.CampusId" placeholder="可不选（全校）" style="width: 100%" clearable
                                    @change="handleCampusChange">
                                    <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="登录账号" prop="Account" v-if="editForm.PersonType === 0">
                                <el-input v-model="editForm.Account" maxlength="50" placeholder="请输入账号"></el-input>
                            </el-form-item>
                            <el-form-item label="登录密码" :prop="editForm.Id ? '' : 'Password'" v-if="editForm.PersonType === 0">
                                <el-input v-model="editForm.Password" type="password" show-password maxlength="50"
                                    placeholder="请输入密码" autocomplete="new-password"></el-input>
                            </el-form-item>
                            <!-- 人员：提示 + 勾选 + 选人。最后更新：2026-09-21 -->
                            <el-form-item label="人员" v-if="editForm.PersonType === 0" class="person-pick-item">
                                <span class="duty-staff-hint">
                                    <i class="el-icon-warning-outline"></i>
                                    <span>
                                        可选绑定学生或勾选全校用于刷脸；<br>
                                        不选则仅用上方账号密码登录
                                    </span>
                                </span>
                                <div class="person-pick-compact">
                                    <el-checkbox v-model="allStudentsUi">全校学生有效</el-checkbox>
                                    <div v-if="!editForm.AllStudents" class="ps-pick-summary">
                                        <span v-if="editForm.StudentId">
                                            已选 <strong>{{ selectedPersonLabel || ('学生#' + editForm.StudentId) }}</strong>
                                        </span>
                                        <span v-else class="muted-text">可选，绑定一名学生</span>
                                        <el-button type="primary" size="mini" plain @click="openPersonPicker">选择学生</el-button>
                                        <el-button
                                            v-if="editForm.StudentId"
                                            type="text"
                                            size="mini"
                                            @click="clearStudentPick"
                                        >清空</el-button>
                                    </div>
                                    <div v-if="!editForm.AllStudents" class="form-tip">从通讯录选择，仅绑定一人</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="人员" v-if="editForm.PersonType === 1" class="person-pick-item">
                                <span class="duty-staff-hint">
                                    <i class="el-icon-warning-outline"></i>
                                    可指定一名教职工，或勾选全部教职工有效
                                </span>
                                <div class="person-pick-compact">
                                    <el-checkbox v-model="allTeachersUi">全部教职工有效</el-checkbox>
                                    <el-form-item v-if="!allTeachersUi" label-width="0" class="duty-staff-nested-form-item" prop="TeacherId">
                                        <div class="ps-pick-summary">
                                            <span v-if="editForm.TeacherId">
                                                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
                                            </span>
                                            <span v-else class="muted-text">请选择一名教职工</span>
                                            <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
                                            <el-button
                                                v-if="editForm.TeacherId"
                                                type="text"
                                                size="mini"
                                                @click="clearTeacherPick"
                                            >清空</el-button>
                                        </div>
                                        <div class="form-tip">从通讯录选择，仅绑定一人</div>
                                    </el-form-item>
                                    <div v-else class="muted-text">已设为全部教职工有效</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="姓名" prop="Name">
                                <el-input v-model="editForm.Name" maxlength="50" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="值周检查">
                                <el-switch v-model="editForm.CanDutyInspect" active-text="可检查" inactive-text="否"></el-switch>
                                <div class="form-tip">关闭后不能进值周检查。可只开黑板报。</div>
                            </el-form-item>
                            <el-form-item label="黑板报">
                                <el-switch v-model="editForm.CanBlackboard" active-text="可上传" inactive-text="否"></el-switch>
                                <div class="form-tip">开启后可在值周 APK 拍照上传黑板报，与值周检查互不影响。</div>
                            </el-form-item>
                            <el-form-item label="启用状态">
                                <el-switch v-model="editForm.Enabled"></el-switch>
                            </el-form-item>
                            <el-form-item label="权限等级">
                                <el-switch v-model="editForm.IsAdmin" :disabled="isAllTeachersAdminDisabled"
                                    active-text="管理员" inactive-text="普通"></el-switch>
                                <div class="form-tip">
                                    普通仅可改本人记录；管理员可改全校检查记录
                                </div>
                                <div v-if="isAllTeachersAdminDisabled" class="form-tip" style="color: #E6A23C;">
                                    「全部教职工有效」不可设为管理员
                                </div>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input type="textarea" v-model="editForm.Remark" :rows="4" maxlength="500"
                                    placeholder="选填"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="personPickerVisible"
                :directory-scope="personPickerScope"
                :show-scope-tabs="false"
                :scope-department-id="resolveSchoolIdForForm()"
                :value="personPickerValue"
                :label="selectedPersonLabel"
                @confirm="onPersonPicked"
            />
        </section>
    </section>
</template>

<script>
import { getDutyStaffListPage, addDutyStaff, editDutyStaff, removeDutyStaff, getCampusList } from '../../api/modules/misc';
import { resolveActiveSchoolId, normalizeDeptId, toDeptId } from '../../utils/deptCascaderProps';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog'

export default {
    components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
    data() {
        return {
            filters: {
                campusId: null
            },
            campusOptions: [],
            searchList: [
                { label: '姓名/账号', key: 'name' },
                {
                    label: '选择校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    options: [], // 将在运行时同步
                },
            ],
            users: [],
            total: 0,
            page: 1,
            PageSize: 10,
            listLoading: false,
            buttonList: [],
            DepartmentId: 0,

            // 编辑相关
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            personPickerVisible: false,
            selectedPersonLabel: '',
            editFormRules: {
                CampusId: [],
                Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                Account: [{
                    validator: (rule, value, callback) => {
                        if (this.editForm.PersonType === 0 && !value) {
                            callback(new Error('请输入账号'));
                        } else { callback(); }
                    }, trigger: "blur"
                }],
                Password: [{
                    validator: (rule, value, callback) => {
                        if (this.editForm.PersonType === 0 && !this.editForm.Id && !value) {
                            callback(new Error('请输入密码'));
                        } else { callback(); }
                    }, trigger: "blur"
                }],
                TeacherId: [{
                    validator: (rule, value, callback) => {
                        // 教职工可选“全部有效”，此时无需指定某个人
                        if (this.editForm.PersonType === 1 && !this.editForm.AllTeachers && Number(value || this.editForm.TeacherId || 0) <= 0) {
                            callback(new Error('请选择教职工'));
                        } else { callback(); }
                    }, trigger: "change"
                }],
            },
            editForm: {
                Id: 0,
                Name: '',
                Account: '',
                Password: '',
                PersonType: 0,
                DepartmentId: 0,
                CampusId: null,
                StudentId: null,
                TeacherId: null,
                AllTeachers: false,
                AllStudents: false,
                Enabled: true,
                IsAdmin: false,
                BizScope: 'DutyInspect',
                CanDutyInspect: true,
                CanBlackboard: false,
                Remark: '',
            },
            isManualChange: false, // 标识是否为人工手动操作（用于区分初始化加载）
        };
    },
    methods: {
        /** 业务范围文案（旧数据空视为仅值周）。创建于 2026-09-14 */
        formatBizScope(scope) {
            if (scope === 'Both') return '值周+宿舍';
            if (scope === 'DormInspect') return '仅宿舍';
            if (scope === 'None') return '仅黑板报';
            return '仅值周';
        },
        /** 空或值周/双业务视为有值周检查；None、仅宿舍没有。最后更新：2026-09-24 */
        scopeHasDuty(scope) {
            return scope !== 'None' && scope !== 'DormInspect';
        },
        /** 提交时按开关合并范围，宿舍权限由后端保留。最后更新：2026-09-24 */
        resolveBizScope(loadedScope, canDutyInspect) {
            const loaded = loadedScope || 'DutyInspect';
            const hasDorm = loaded === 'DormInspect' || loaded === 'Both';
            if (canDutyInspect && hasDorm) return 'Both';
            if (canDutyInspect) return 'DutyInspect';
            if (hasDorm) return 'DormInspect';
            return 'None';
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            // 顶栏切校也会经 DepartmentPane 触发此处，必须清掉旧校区筛选
            this.clearCampusFilter();
            this.loadCampusOptions(this.DepartmentId);
            this.handleQuery();
        },
        /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
        clearCampusFilter() {
            this.filters = { ...(this.filters || {}), campusId: null };
            this.campusOptions = [];
            const campusSearch = this.searchList.find((e) => e.key === 'campusId');
            if (campusSearch) campusSearch.options = [];
            if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
            }
        },
        handleQuery() {
            this.page = 1;
            this.getUsers();
        },
        getUsers() {
            let para = {
                page: this.page,
                intPageSize: this.PageSize,
                departmentId: this.DepartmentId,
                ...this.filters
            };
            this.listLoading = true;
            getDutyStaffListPage(para).then((res) => {
                const resp = res.data.response || {};
                const rows = resp.data || [];
                this.users = rows;
                this.total = resp.dataCount != null ? resp.dataCount : rows.length;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.getUsers();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = {
                    name: item.search
                };
            }
            this[item.Func].apply(this, item)
        },
        /**
         * 解析当前学校 ID（顶部固定学校优先）。最后更新：2026-08-29
         */
        resolveSchoolIdForForm() {
            return resolveActiveSchoolId(this)
                || normalizeDeptId(this.DepartmentId)
                || '';
        },
        handleAdd() {
            const schoolId = this.resolveSchoolIdForForm();
            if (!schoolId) {
                this.$message.warning('请先在顶部选择学校');
                return;
            }
            this.dialogTitle = "新增值周人员";
            this.editFormVisible = true;
            this.selectedPersonLabel = '';
            this.editForm = {
                Id: 0,
                Name: '',
                Account: '',
                Password: '',
                PersonType: 0,
                // 学校由顶部固定，表单只选校区
                DepartmentId: schoolId,
                CampusId: this.filters.campusId,
                StudentId: null,
                TeacherId: null,
                AllTeachers: false,
                AllStudents: false,
                Enabled: true,
                IsAdmin: false,
                BizScope: 'DutyInspect',
                CanDutyInspect: true,
                CanBlackboard: false,
                Remark: '',
            };
            this.isManualChange = true;

            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });

            this.loadCampusOptions(schoolId);
            this.$nextTick(() => { this.isManualChange = true; });
        },
        handleEdit(row) {
            this.dialogTitle = "编辑值周人员";
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);

            // 旧数据兼容：如果PersonType是undefined或者没赋上，视为0(学生)
            if (this.editForm.PersonType === undefined) {
                this.editForm.PersonType = 0;
            }
            this.$set(this.editForm, 'IsAdmin', !!this.editForm.IsAdmin);
            this.$set(this.editForm, 'BizScope', row.BizScope || 'DutyInspect');
            this.$set(this.editForm, 'CanDutyInspect', this.scopeHasDuty(row.BizScope));
            this.$set(this.editForm, 'CanBlackboard', !!this.editForm.CanBlackboard);

            // 处理校区为0的情况，避免显示0，使用 $set 确保响应式
            if (this.editForm.CampusId === 0 || this.editForm.CampusId === '0') {
                this.$set(this.editForm, 'CampusId', null);
            }

            // 全校学生存库为 StudentId=-1；0 表示未指定学生。必须用 $set，保证从列表行合并来的对象上该字段响应式（否则复选框无法勾选）
            const allStudents = this.editForm.PersonType === 0 && Number(this.editForm.StudentId) === -1;
            this.$set(this.editForm, 'AllStudents', allStudents);
            if (allStudents) {
                this.$set(this.editForm, 'StudentId', null);
                this.selectedPersonLabel = '';
            } else if (this.editForm.PersonType === 0 && Number(this.editForm.StudentId) > 0) {
                this.selectedPersonLabel = row.StudentName || row.Name || '';
            } else if (this.editForm.PersonType !== 1) {
                this.selectedPersonLabel = '';
            }

            // 仅教职工分支改 TeacherId / 已选文案，避免学生记录因 TeacherId=0 把姓名清掉。最后更新：2026-09-21
            if (this.editForm.PersonType === 1) {
                const isAllTeachers = Number(this.editForm.TeacherId || 0) <= 0;
                this.$set(this.editForm, 'AllTeachers', isAllTeachers);
                if (isAllTeachers) {
                    this.$set(this.editForm, 'TeacherId', null);
                    this.$set(this.editForm, 'IsAdmin', false);
                    this.selectedPersonLabel = '';
                } else {
                    this.selectedPersonLabel = row.TeacherName || row.Name || '';
                }
            } else {
                this.$set(this.editForm, 'AllTeachers', false);
                if (Number(this.editForm.TeacherId || 0) <= 0) {
                    this.$set(this.editForm, 'TeacherId', null);
                }
            }
            this.$nextTick(() => {
                if (this.$refs.editForm) {
                    this.$refs.editForm.clearValidate();
                }
            });

            const schoolId = this.resolveSchoolIdForForm() || toDeptId(row.DepartmentId);
            this.editForm.DepartmentId = schoolId || row.DepartmentId;
            this.loadCampusOptions(schoolId);

            this.$nextTick(() => { this.isManualChange = true; });
        },
        handleDel(row) {
            this.$confirm('确认移除该人员的值周检查权限吗？（若仍有宿舍权限将保留）', '提示', { type: 'warning' }).then(() => {
                this.listLoading = true;
                removeDutyStaff({ id: row.Id }).then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.$message({ message: res.data.msg || '删除成功', type: 'success' });
                        this.getUsers();
                    }
                });
            });
        },
        loadCampusOptions(deptId) {
            const schoolId = this.resolveSchoolIdForForm() || deptId || this.editForm.DepartmentId || 0;
            if (!normalizeDeptId(schoolId)) return;
            getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                if (res.data.success) {
                    this.campusOptions = res.data.response.data || [];
                    const campusSearch = this.searchList.find(e => e.key === 'campusId');
                    if (campusSearch) {
                        campusSearch.options = this.campusOptions.map(e => ({
                            label: e.Name,
                            value: e.Id
                        }));
                    }
                }
            });
        },
        openPersonPicker() {
            const schoolId = this.resolveSchoolIdForForm();
            if (!schoolId) {
                this.$message.warning('请先在顶部选择学校');
                return;
            }
            this.personPickerVisible = true;
        },
        clearStudentPick() {
            this.$set(this.editForm, 'StudentId', null);
            this.selectedPersonLabel = '';
        },
        clearTeacherPick() {
            this.$set(this.editForm, 'TeacherId', null);
            this.selectedPersonLabel = '';
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
            });
        },
        onPersonPicked(person) {
            if (!person) return;
            const id = person.id;
            const name = person.name || '';
            if (this.editForm.PersonType === 1) {
                this.$set(this.editForm, 'AllTeachers', false);
                this.$set(this.editForm, 'TeacherId', id);
                this.selectedPersonLabel = name;
                if (name) this.editForm.Name = name;
                this.$nextTick(() => {
                    if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
                });
                return;
            }
            this.$set(this.editForm, 'AllStudents', false);
            this.$set(this.editForm, 'StudentId', id);
            this.selectedPersonLabel = name;
            if (name) this.editForm.Name = name;
        },
        handleAllStudentsStudentChange(val) {
            if (val) {
                this.clearStudentPick();
                if (!this.editForm.Name) this.editForm.Name = '学生值周';
            }
        },
        async editSubmit() {
            this.$refs.editForm.validate(async (valid) => {
                if (!valid) return;

                const schoolId = this.resolveSchoolIdForForm();
                if (!schoolId) {
                    this.$message.warning('请先在顶部选择学校');
                    return;
                }
                this.editForm.DepartmentId = schoolId;

                if (!this.editForm.CanDutyInspect && !this.editForm.CanBlackboard) {
                    this.$message.warning('请至少开启值周检查或黑板报');
                    return;
                }
                const para = Object.assign({}, this.editForm);
                para.BizScope = this.resolveBizScope(para.BizScope, para.CanDutyInspect);
                // 校区可不选：空视为全校（CampusId=0）。创建于 2026-09-24
                if (para.CampusId === null || para.CampusId === undefined || para.CampusId === '') {
                    para.CampusId = 0;
                }

                if (para.PersonType === 1) {
                    para.StudentId = null;
                    para.Account = '';
                    para.Password = '';
                    if (para.AllTeachers) {
                        para.TeacherId = null;
                        para.IsAdmin = false;
                    }
                } else if (para.PersonType === 0) {
                    para.TeacherId = null;
                    if (para.AllStudents) {
                        para.StudentId = -1;
                    } else if (!(Number(para.StudentId) > 0)) {
                        para.StudentId = null;
                    }
                }

                delete para.AllTeachers;
                delete para.AllStudents;
                delete para.CanDutyInspect;

                this.editLoading = true;
                try {
                    const apiCall = para.Id > 0 ? editDutyStaff : addDutyStaff;
                    const res = await apiCall(para);
                    if (res.data.success) {
                        this.$message({ message: '提交成功', type: 'success' });
                        this.editFormVisible = false;
                        this.getUsers();
                    } else {
                        this.$message.error(res.data.msg || '提交失败');
                    }
                } catch (e) {
                    this.$message.error('提交失败');
                } finally {
                    this.editLoading = false;
                }
            });
        },
        handlePersonTypeChange() {
            this.$refs.editForm.clearValidate();
            this.editForm.StudentId = null;
            this.editForm.TeacherId = null;
            this.editForm.AllTeachers = false;
            this.$set(this.editForm, 'AllStudents', false);
            this.selectedPersonLabel = '';
        },
        handleCampusChange() {
            if (this.isManualChange) {
                if (this.editForm.PersonType === 0) {
                    this.clearStudentPick();
                    this.$set(this.editForm, 'AllStudents', false);
                } else if (this.editForm.PersonType === 1) {
                    this.clearTeacherPick();
                }
            }
        },
        getCampusName(campusId) {
            if (!campusId || campusId === 0 || campusId === '0' || !this.campusOptions.length) return '-';
            const campus = this.campusOptions.find(c => c.Id === campusId);
            return campus ? campus.Name : '-';
        },
        handleAllTeachersChange(val) {
            if (val) {
                this.$set(this.editForm, 'TeacherId', null);
                this.$set(this.editForm, 'IsAdmin', false);
                this.selectedPersonLabel = '';
                if (!this.editForm.Name) {
                    this.editForm.Name = '教职工';
                }
            } else {
                if (Number(this.editForm.TeacherId || 0) <= 0) {
                    this.$set(this.editForm, 'TeacherId', null);
                }
                this.$nextTick(() => {
                    if (this.$refs.editForm) {
                        this.$refs.editForm.clearValidate(['TeacherId']);
                    }
                });
            }
        },
    },
    computed: {
        personPickerScope() {
            return this.editForm.PersonType === 1 ? 'internal' : 'teaching';
        },
        personPickerValue() {
            return this.editForm.PersonType === 1 ? this.editForm.TeacherId : this.editForm.StudentId;
        },
        isAllTeachersAdminDisabled() {
            return this.editForm.PersonType === 1 && !!this.editForm.AllTeachers;
        },
        allTeachersUi: {
            get() {
                return !!this.editForm.AllTeachers;
            },
            set(val) {
                const next = !!val;
                this.$set(this.editForm, 'AllTeachers', next);
                this.handleAllTeachersChange(next);
            }
        },
        allStudentsUi: {
            get() {
                return !!this.editForm.AllStudents;
            },
            set(val) {
                const next = !!val;
                this.$set(this.editForm, 'AllStudents', next);
                this.handleAllStudentsStudentChange(next);
            }
        }
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({
                name: '查询',
                Func: 'handleQuery',
                id: 999
            });
        }
    }
};
</script>

<style scoped>
.duty-staff-edit-form {
    padding: 0 4px;
}

.person-pick-compact {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
}

.person-pick-item {
    margin-bottom: 22px;
}

.duty-staff-nested-form-item {
    margin-bottom: 0;
    margin-top: 0;
    width: 100%;
}

.duty-staff-nested-form-item >>> .el-form-item__content {
    margin-left: 0 !important;
}

/* 嵌套校验错误改为占位，避免绝对定位压到下方「姓名」 */
.duty-staff-nested-form-item >>> .el-form-item__error {
    position: static;
    padding-top: 4px;
    line-height: 1.4;
}

.duty-staff-hint {
    color: #E6A23C;
    font-size: 13px;
    margin-bottom: 8px;
    display: flex;
    align-items: flex-start;
    line-height: 1.5;
}

.duty-staff-hint i {
    margin-right: 4px;
    margin-top: 3px;
    flex-shrink: 0;
}

.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 6px;
}

.muted-text {
    color: #94a3b8;
}

.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}
</style>
